import React from 'react';
import Acknowledgement from './acknowledgement';
import {useTranslation} from 'react-i18next';
import { useState, useEffect } from 'react';
import LoadingIndicator from "../components/loadingIndicator";

const Home = () => {

    const mediaQuery = '(max-width: 425px)';
    const pageTitleText = smallText => smallText ? 'WRA' : 'Work Rules Acknowledgement';
    
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [pageTitle, setPageTitle] = useState(pageTitleText(window.matchMedia(mediaQuery).matches));

    useEffect(()=>{
        // for manual or automatic refreshes, do not attempt to scroll back to position in the form. stay at the top.
        window.history.scrollRestoration = 'manual';
        
        const mediaQueryList = window.matchMedia(mediaQuery);
        mediaQueryList.addEventListener('change', event => {
            setPageTitle(pageTitleText(event.matches));
        })
    })

    function handleLoadingChange(isLoading) {
        setIsLoading(isLoading);
    }
    
    return (
        <>
        {isLoading && <LoadingIndicator />}
        
        <div className='mt-3 container'>
            <h4 className=''>{t(pageTitle)}</h4>
            <hr />
            <div className='fst-italic'>
                {t('RegistrationAcknowledgement')}
            </div>
            <Acknowledgement loadingChange={handleLoadingChange} />
            <div className='fst-italic fs-6 border-top border-bottom my-2 py-1'>
            {t('LegalComm')}
            </div>
        </div>
        </>
    )
}

export default Home;